// Cleans a percentage value: clamps it between 0 and 100, and handles NaN/infinity
export const cleanPercentage = (percentage: unknown): number => {
  const num = Number(percentage)

  if (!Number.isFinite(num) || num < 0) return 0
  if (num > 100) return 100

  return num
}
